import { CardActions, CardContent, Typography, Button, Box, Chip } from "@mui/material";
import React, { Component } from "react";
import { Card } from "react-bootstrap";
import { AddShoppingCart, Euro, MonitorWeight } from "@mui/icons-material";

class ProductItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            product: props.product,
            isHovered: false
        }
    }

    componentDidUpdate() {
        if (this.state.product !== this.props.product) {
            this.setState({ product: this.props.product });
        }
    }

    selectProduct() {
        this.props.selectedProduct(this.state.product);
    }

    render() {
        const { isHovered } = this.state;
        const { isFixed, Price, Weight, Name } = this.state.product;

        return (
            <Card 
                style={{ 
                    width: window.innerWidth < 600 ? "100%" : window.innerWidth < 900 ? "calc(50% - 12px)" : "350px",
                    minWidth: window.innerWidth < 600 ? "100%" : "280px",
                    minHeight: "240px", 
                    display: "flex", 
                    flexDirection: "column", 
                    justifyContent: "space-between",
                    borderRadius: "16px",
                    border: isHovered ? "2px solid #2e7d32" : "2px solid #e0e0e0",
                    boxShadow: isHovered 
                        ? "0 12px 24px rgba(46, 125, 50, 0.15)" 
                        : "0 4px 12px rgba(0, 0, 0, 0.08)",
                    transform: window.innerWidth >= 600 && isHovered ? "translateY(-8px)" : "translateY(0)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    cursor: "pointer",
                    overflow: "hidden",
                    position: "relative"
                }} 
                onMouseEnter={() => this.setState({ isHovered: true })}
                onMouseLeave={() => this.setState({ isHovered: false })}
                onClick={() => this.selectProduct()}
            >
                {/* Decorative accent bar */}
                <Box 
                    sx={{ 
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "4px",
                        background: "linear-gradient(90deg, #2e7d32 0%, #66bb6a 100%)",
                        transform: isHovered ? "scaleX(1)" : "scaleX(0)",
                        transformOrigin: "left",
                        transition: "transform 0.3s ease"
                    }}
                />

                <CardContent sx={{ pt: { xs: 2, sm: 3 }, pb: 1, px: { xs: 2, sm: 3 } }}>
                    <Typography 
                        variant="h5" 
                        component="div"
                        sx={{
                            fontWeight: 600,
                            color: "#1a1a1a",
                            mb: { xs: 2, sm: 2.5 },
                            lineHeight: 1.3,
                            minHeight: { xs: "auto", sm: "60px" },
                            fontSize: { xs: '1.25rem', sm: '1.5rem' },
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        {Name}
                    </Typography>
                    
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                        {/* Price Section */}
                        <Box sx={{ 
                            display: "flex", 
                            alignItems: "center", 
                            gap: { xs: 0.8, sm: 1 },
                            p: { xs: 1.2, sm: 1.5 },
                            bgcolor: isFixed ? "#e8f5e9" : "#fff3e0",
                            borderRadius: "8px",
                            transition: "all 0.2s ease"
                        }}>
                            <Euro sx={{ 
                                color: isFixed ? "#2e7d32" : "#f57c00",
                                fontSize: { xs: "1rem", sm: "1.2rem" }
                            }} />
                            <Box sx={{ flex: 1 }}>
                                <Typography 
                                    variant="caption" 
                                    sx={{ 
                                        display: "block",
                                        color: "#666",
                                        fontSize: "0.7rem",
                                        fontWeight: 500,
                                        mb: 0.3
                                    }}
                                >
                                    PREIS
                                </Typography>
                                <Typography 
                                    variant="body1"
                                    sx={{ 
                                        fontWeight: 600,
                                        color: isFixed ? "#2e7d32" : "#666",
                                        fontSize: isFixed ? "1.1rem" : "0.85rem"
                                    }}
                                >
                                    {isFixed ? `${Price}€` : "Nach Bestätigung"}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Weight Section */}
                        <Box sx={{ 
                            display: "flex", 
                            alignItems: "center", 
                            gap: { xs: 0.8, sm: 1 },
                            p: { xs: 1.2, sm: 1.5 },
                            bgcolor: isFixed ? "#e8f5e9" : "#fff3e0",
                            borderRadius: "8px",
                            transition: "all 0.2s ease"
                        }}>
                            <MonitorWeight sx={{ 
                                color: isFixed ? "#2e7d32" : "#f57c00",
                                fontSize: { xs: "1rem", sm: "1.2rem" }
                            }} />
                            <Box sx={{ flex: 1 }}>
                                <Typography 
                                    variant="caption" 
                                    sx={{ 
                                        display: "block",
                                        color: "#666",
                                        fontSize: "0.7rem",
                                        fontWeight: 500,
                                        mb: 0.3
                                    }}
                                >
                                    GEWICHT
                                </Typography>
                                <Typography 
                                    variant="body1"
                                    sx={{ 
                                        fontWeight: 600,
                                        color: isFixed ? "#2e7d32" : "#666",
                                        fontSize: isFixed ? "1.1rem" : "0.85rem"
                                    }}
                                >
                                    {isFixed ? `${Weight} Kg/L` : "Nach Bestätigung"}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Fixed Price Badge */}
                    {isFixed ? (
                        <Chip 
                            label="Festpreis" 
                            size="small"
                            sx={{ 
                                mt: 1.5,
                                bgcolor: "#2e7d32",
                                color: "white",
                                fontWeight: 600,
                                fontSize: "0.7rem"
                            }}
                        />
                    ) : <></>}
                </CardContent>

                <CardActions sx={{ p: { xs: 1.5, sm: 2 }, pt: 0 }}>
                    <Button 
                        variant="contained"
                        fullWidth
                        size="large"
                        startIcon={<AddShoppingCart sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.selectProduct();
                        }}
                        sx={{
                            bgcolor: "#2e7d32",
                            color: "white",
                            fontWeight: 600,
                            textTransform: "none",
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            py: { xs: 1, sm: 1.2 },
                            borderRadius: "10px",
                            boxShadow: isHovered ? "0 6px 16px rgba(46, 125, 50, 0.3)" : "none",
                            transform: window.innerWidth >= 600 && isHovered ? "scale(1.02)" : "scale(1)",
                            transition: "all 0.2s ease",
                            "&:hover": {
                                bgcolor: "#1b5e20",
                            }
                        }}
                    >
                        Zum Warenkorb hinzufügen
                    </Button>
                </CardActions>
            </Card>
        )
    }
}

export default ProductItem;